<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <div class="row">
                        <div class="col col-12">
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Leadin" tag-name="h3" :init="EditorConfig" />
                        </div>
                    </div>
                    <div class="row justify-content-lg-between align-items-lg-center" :style="{ 'flex-direction': BlockProps.Flipped ? 'row-reverse' : 'row' }">
                        <!-- End Col -->
                        <div class="col-lg-6">
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Content" tag-name="div" :init="EditorConfig" />
                        </div>
                        <!-- End Col -->
                        <div class="col-7 col-lg-5 mb-7 mb-lg-0">
                            <img class="img-fluid rounded-3 shadow-xl" style="border:1px solid lightgray;" :src="BlockProps.Img1" alt="Image 1">
                        </div>
                    </div>
                    <!-- End Row -->
                </div>
            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <propertytogglededitor propertyname="Shadows" :blockprops="BlockProps" prompt="Inner Drop Shadows"></propertytogglededitor>

                        <small style="font-size:12px;"><i class="bi bi-info-circle"></i>  Background Image (75kb max, each)</small>
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <div class="row">
                            <div class="col col-12 text">
                                <div style="display:inline-block; width: 100px !important;height: 75px !important;">
                                    <img style="object-fit:cover; width:100% !important; height:100% !important;object-position:center  !important;box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; border: 1px solid black" :src="BlockProps.Img1" alt="Image1" />
                                </div>
                                <i class="bi bi-chevron-double-right"></i>
                                <button @click="UploadNewSlideBackground(1)" type="button" style="margin-left:5px;" class="btn btn-sm btn-primary"><i class="bi bi-image"></i> Change Image</button>
                            </div>
                            <hr style="margin-top: 5px; margin-bottom:5px;" />
                        </div>

                        <propertytogglededitor propertyname="Flipped" :blockprops="BlockProps" prompt="Flip Layout"></propertytogglededitor>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    export default {
        inheritAttrs: false,
        name: 'FeatureSingle',
        mixins: [ContentBlockBase],
        props: [],
        components: {
        },
        computed:
        {
           
        },
        data() {
            return {  
         
            };
        },
        methods:
        {
            OnSlideImageUploaded: function (args) {
                if (args.success)
                {
                    if (this.BlockProps[args.idx] && args.url){
                        this.BlockProps[args.idx] = args.url;                    
                    }
                }
                
                this.EditProperties();
            },
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            UploadNewSlideBackground: function(idx){
                this.HideEditProperties();
                var args = {};  

                var imgProp = 'Img' + idx;
                args.ExistingFileURL = this.BlockProps[imgProp];
                args.CompleteCallback = "OnSlideImageUploaded-" + this.BlockProps.UId;
                args.CompleteCallbackData = { MaxSize: 1024 * 75, idx: imgProp, url: ''}; // this will be sent back in the callback
                args.Prompt = `Image`;
                EventHub.$emit('UploadNewAssetBlockConfig', args);
            }
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            EventHub.$on('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        beforeUnmount()
        {
            EventHub.$off('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        mounted() {
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>

